import { render, staticRenderFns } from "./SelectPlacement.vue?vue&type=template&id=97ada602"
import script from "./SelectPlacement.vue?vue&type=script&lang=ts"
export * from "./SelectPlacement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97ada602')) {
      api.createRecord('97ada602', component.options)
    } else {
      api.reload('97ada602', component.options)
    }
    module.hot.accept("./SelectPlacement.vue?vue&type=template&id=97ada602", function () {
      api.rerender('97ada602', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminder-layout-editor/SelectPlacement.vue"
export default component.exports